import { api } from './api';
import type {
  CreateOverridePayload,
  ExecutionDetail,
  ExecutionSummary,
  OverrideRecord,
  TriggerResponse,
  WorkflowDetail,
  WorkflowStats,
  WorkflowSummary,
} from '@/types/workflow';

export const workflowsApi = {
  list: (active?: boolean) =>
    api.get<WorkflowSummary[]>(
      `/workflows${active !== undefined ? `?active=${active}` : ''}`,
    ),
  get: (id: string) => api.get<WorkflowDetail>(`/workflows/${id}`),
  executions: (id: string, limit = 20) =>
    api.get<ExecutionSummary[]>(`/workflows/${id}/executions?limit=${limit}`),
  stats: (id: string, sample = 50) =>
    api.get<WorkflowStats>(`/workflows/${id}/stats?sample=${sample}`),
  trigger: (id: string) => api.post<TriggerResponse>(`/workflows/${id}/trigger`),
  activate: (id: string) => api.post<WorkflowSummary>(`/workflows/${id}/activate`),
  deactivate: (id: string) => api.post<WorkflowSummary>(`/workflows/${id}/deactivate`),
  createOverride: (id: string, payload: CreateOverridePayload) =>
    api.post<OverrideRecord>(`/workflows/${id}/overrides`, payload),
  listOverrides: (id: string) =>
    api.get<OverrideRecord[]>(`/workflows/${id}/overrides`),
};

export const executionsApi = {
  list: (params: { workflowId?: string; status?: string; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.workflowId) qs.set('workflowId', params.workflowId);
    if (params.status) qs.set('status', params.status);
    qs.set('limit', String(params.limit ?? 20));
    return api.get<ExecutionSummary[]>(`/executions?${qs}`);
  },
  get: (id: string) => api.get<ExecutionDetail>(`/executions/${id}`),
  rerun: (id: string) => api.post<TriggerResponse>(`/executions/${id}/rerun`),
};

export const overridesApi = {
  listAll: () => api.get<OverrideRecord[]>('/overrides'),
};
